<template>
	<span>

		<Menu/>

		<b-row align-h="between">
			<b-col cols="3">
				<p class="display-1 text-center">
					<b-icon-exclamation-diamond-fill variant="danger"/>
				</p>
			</b-col>
			<b-col>
				<p class="display-4 text-left" v-if="typeof message != 'undefined' && message !== null && typeof message.body != 'undefined' && message.body !== null">
					{{message.body}}
				</p>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<p class="lead text-center">
					Principal Task has encountered an error.  Please <b-link @click="logout()">logout</b-link>, 
					close all of your browsers, and try again. <br/> If the problem persists, 
					contact support@principaltask.com and include the content below.
				</p>
			</b-col>
		</b-row>
		<b-row  align-h="center">
			<b-col>
				<pre><code>ptUser: {{this.$store.getters.getUser}}, <br/>auth0User: {{this.$auth.user}}, <br/>message: {{message}}, <br/>info: {{info}}</code></pre>
			</b-col>
		</b-row>

	</span>
</template>

<script>

import genericOps from '@/mixins/genericOps'
import Menu from '@/components/menus/Menu4.vue'

export default {
	name: 'Error',
	components: {
		Menu
	},
	mixins: [genericOps],
	data() {
		return {
			message: {
				title: null,
				body: null,
				variant: null
			},
			info: {
				timeOpened:new Date(),
				timezone:(new Date()).getTimezoneOffset()/60,
				pageonpageon: window.location.pathname,
				referrer: document.referrer,
				previousSites: history.length,
				browserName: navigator.appName,
				browserEngine: navigator.product,
				browserVersion1a: navigator.appVersion,
				browserVersion1b: navigator.userAgent,
				browserLanguage: navigator.language,
				browserOnline: navigator.onLine,
				browserPlatform: navigator.platform,
				javaEnabled:  navigator.javaEnabled(),
				dataCookiesEnabled: navigator.cookieEnabled,
				dataCookies1: document.cookie,
				dataCookies2: decodeURIComponent(document.cookie.split(";")),
				dataStorage: localStorage,
				sizeScreenW: screen.width,
				sizeScreenH: screen.height,
				sizeDocW:  document.width,
				sizeDocH: document.height,
				sizeInW: innerWidth,
				sizeInH: innerHeight,
				sizeAvailW: screen.availWidth,
				sizeAvailH: screen.availHeight,
				scrColorDepth: screen.colorDepth,
				scrPixelDepth: screen.pixelDepth,


				},
		}
	},
	mounted() {
		
		this.message = this.$route.params.message
        
		if(typeof this.message != 'undefined' && this.message !== null &&
			typeof this.message.title != 'undefined' && this.message.title !== null && 
			typeof this.message.body != 'undefined' && this.message.body !== null) {
			this.makeToast(true, this.message.title, this.message.body, this.message.variant)
		}
	},
	methods: {
		logout() {
			this.$auth.logout({
				returnTo: window.location.origin
			});
		}
	}
}
</script>